module.exports = __webpack_public_path__ + "static/media/logoConfiaEmpresas.2a90acd2.png";